import React from 'react'
import AntDatePicker from 'components/Common/DayjsDatePicker'
import {
  filterSavedDates,
  formatDate,
  formatDatesWithOrders,
  getDates
} from './helpers'
import dayjs, { Dayjs } from 'dayjs'
import { OperationVariables } from 'react-apollo'
import { ApolloQueryResult } from '@apollo/client'
import { EventValue, RangeValue } from 'rc-picker/lib/interface'
import classnames from 'classnames'
import styled from '@emotion/styled'

type DatesWithOrdersType = { [key: string]: string[] }

const DatePicker = ({
  datesWithOrders,
  fetchDatesWithOrdersByMonth,
  merchantId,
  storeId,
  setDatesWithOrders,
  orderDateOnchangeHandler
}: {
  datesWithOrders: DatesWithOrdersType
  fetchDatesWithOrdersByMonth: (
    variables?: Partial<OperationVariables>
  ) => Promise<ApolloQueryResult<any>>
  merchantId: string
  storeId: string
  setDatesWithOrders: (datesWithOrders: DatesWithOrdersType) => void
  orderDateOnchangeHandler: (dateRange: RangeValue<Dayjs>) => void
}) => {
  const handleDatePickerChange = (values: EventValue<Dayjs>[]) => {
    const dates = filterSavedDates(
      getDates(values),
      Object.keys(datesWithOrders)
    )
    const jobs = dates.map((date) =>
      fetchDatesWithOrdersByMonth({
        merchantId,
        storeId,
        date: formatDate(date)
      })
        .then((res) => ({
          month: formatDate(date, 'YYYY-MM'),
          dates: res.data.dates
        }))
        .catch((err) => {
          console.error(
            `Failed to fetch dates with orders on ${formatDate(
              date,
              'YYYY-MM'
            )}:`,
            err
          )
          throw new Error(err)
        })
    )

    Promise.all(jobs)
      .then((res) =>
        setDatesWithOrders(formatDatesWithOrders(res, datesWithOrders))
      )
      .catch((err) => console.error('Failed to fetch dates with orders:', err))
  }

  return (
    <StyledDatePicker
      onOpenChange={(open) => {
        if (!open || !storeId) return
        handleDatePickerChange([dayjs()])
      }}
      suffixIcon={null}
      onPanelChange={(values) => values && handleDatePickerChange(values)}
      onChange={orderDateOnchangeHandler}
      defaultValue={[dayjs(), dayjs()]}
      format='DD/MM/YYYY'
      dateRender={(dayjsDate) => {
        const formattedDate = formatDate(dayjsDate)
        const key = formatDate(dayjsDate, 'YYYY-MM')
        const hasOrder = (datesWithOrders[key] || []).includes(formattedDate)
        return (
          <div
            title={formattedDate}
            className='ant-picker-cell ant-picker-cell-in-view'
            style={{ width: '100%' }}
            key={`date-picker-date-${formattedDate}`}
          >
            <div
              className={classnames([
                'ant-picker-cell-inner',
                hasOrder ? '-has-orders' : ''
              ])}
            >
              {dayjsDate.date()}
              <div className='dot' />
            </div>
          </div>
        )
      }}
    />
  )
}

const StyledDatePicker = styled(AntDatePicker.RangePicker)`
  padding: 0px 25px 0 40px;

  .ant-picker-input {
    width: 80px;

    input {
      padding-top: 2px;
    }
  }

  .ant-picker-clear {
    right: 8px;
  }

  .ant-picker-range-separator {
    padding: 0 4px;
  }
`
export default DatePicker
